<template>
  <div>
    <AlertaPlano
      text="PLANO GRATUITO"
      callbackText="ASSINAR"
      :callback="() => $router.back()"
      :plan="true"
      :backButton="true"
      :isMobile="isMobile"

      :screenName="this.namePdf"
    />

    <div id="containerPDF" style="height: 86vh"></div>
  </div>
</template>

<script>
import AlertaPlano from "../components/AlertaPlano";
import axios from "axios";

export default {
  components: {
    AlertaPlano,
  },
  data: () => ({
    items: [],
    slider_edicoes: [],
    items_slider: [],
    detalhes_edicao: false,
    namePdf: "",
    linkPdf: "",
    isMobile: false,

  }),
  name: "Home",
  mounted: async function () {
    this.$store.commit("loading", true);
    this.$store.commit("jogo", false);
    this.isMobile = this.$store.getters.isMobile;


    const typeOfContent = this.$route.params.type;
    const idOfContent = this.$route.params.id;

    await axios
      .get(`https://api2.arecreativa.com.br/${typeOfContent}/${idOfContent}`)
      .then(async (bancaRes) => {
        if (typeOfContent == "show_magazine") {
          this.linkPdf = bancaRes.data[0].magazine;
        } else {
          this.linkPdf = bancaRes.data[0].answare;
        }
        this.namePdf = bancaRes.data[0].title;
        console.log("bancaRES", bancaRes);
        console.log("bancaRESdata", bancaRes.data);
        
      })
      .catch(() => {
        this.$store.commit("loading", false);
      });

    let PDF = document.createElement("iframe");
    PDF.setAttribute("style", "height: 100%; width: 100%;");
    PDF.setAttribute("src", this.linkPdf);
    document.getElementById("containerPDF").appendChild(PDF);
    this.$store.commit("loading", false);
    // if (!(localStorage.getItem("t"))) {
    //   this.$router.replace({ path: "/" });
    // }
  },
  created: function () {
    this.analyticSubmit();
  },
  methods: {
    toggleLike(obj) {
      const i = this.items.findIndex((item) => item.id == obj.id);
      this.items[i].usuario_curtiu = obj.like;
      if (obj.like) {
        this.items[i].curtidas_count = this.items[i].curtidas_count + 1;
      } else {
        this.items[i].curtidas_count = this.items[i].curtidas_count - 1;
      }
    },
    analyticSubmit: function () {
      try {
        this.$intercom.trackEvent("ACERVO_tela_Respostas");
      } catch (error) {
        console.log("analyticIntercom banca error:", error);
      }
    },
  },
};
</script>
<style scoped>
.card-promo .oferta {
  font-size: 35px;
  letter-spacing: 2px;
  font-weight: bold;
}

.pdfContainer {
  height: 10vh;
  width: 60vw;
}

.big-icon {
  font-size: 60px !important;
  top: calc(50% - 40px) !important;
}

.info-product {
  font-family: "Agency FB Regular";
  letter-spacing: 2px;
  cursor: pointer;
}

.btn-next {
  position: absolute;
  top: calc(50% - 15px);
  right: 20px;
  color: black;
  font-size: 30px;
  color: black;
  outline: 0;
  z-index: 9999;
  border: none;
}

.btn-prev {
  position: absolute;
  top: calc(50% - 15px);
  left: 20px;
  color: black;
  font-size: 30px;
  z-index: 99999;
  color: black;
  outline: 0;
  border: none;
}

.card {
  border-radius: 0px;
  border: none;
}
</style>
